import { ResourceInfo } from '../models/IConfig';
import { BaseService } from './BaseService';
import { ProfileServiceModule } from '@profile-service/sdk';
import { Profile, BasicProfileData } from '../models/ProfileService.types';
import { IPublicClientApplication } from '@azure/msal-browser';

export class ProfileService extends BaseService {
  private readonly profileServiceClient: ProfileServiceModule.ProfileV2Client;
  public constructor(profileResourceInfo: ResourceInfo, msalInstance: IPublicClientApplication) {
    super(profileResourceInfo, msalInstance);
    //TODO: Need to figure out a way not to have .bind in each service.
    const getAccessToken = this.getAccessToken.bind(this);

    this.profileServiceClient = new ProfileServiceModule.ProfileV2Client(
      { getAuthorization: getAccessToken },
      `${profileResourceInfo.resourceBaseUrl}`
    );
  }

  public async getMyCareerProfile(): Promise<Profile> {
    const response = await this.profileServiceClient.getMyProfile('2.0');
    return response;
  }

  public async getMyHrProfile(): Promise<BasicProfileData> {
    const response = await this.profileServiceClient.getMyHrProfile('2.0');
    return response;
  }
}
